module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// ../js/~/core-js/library/modules/_iter-step.js
// module id = 651
// module chunks = 0